<template>
  <dynameat-row v-bind:class="cardClasses" :title="itemTitle" :is-clickable="false"
                :strong-divider="isLastItem" :disabled="!isEditable" :has-divider="hasDivider">

    <template v-slot:rowIconsLeft v-if="!isSubsection">
      <v-list-item-action class="align-self-auto mr-2 my-0">
        <v-btn class="top-arrow" icon @click="onMove('up')" :disabled="isFirstItemDisabled">
          <v-icon color="black">fa-sort-up</v-icon>
        </v-btn>
        <v-btn class="bottom-arrow" icon @click="onMove('down')" :disabled="isLastItemDisabled">
          <v-icon color="black">fa-sort-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
    <template v-slot:rowIconsRight v-if="!isSubsection">
      <v-checkbox @click="onClickTitle"
                  class="mt-0 pt-2"
                  v-model="isVisible"
                  :disabled="!isEditable || areChecksDisabled"
                  off-icon="mdi-eye-outline"
                  on-icon="mdi-eye"
      />
      <v-checkbox @click="onClickSpecial"
                  class="mt-0 pt-2"
                  v-model="special"
                  :disabled="!isEditable || areChecksDisabled"
                  off-icon="$checkboxStarOff"
                  on-icon="$checkboxStarOn"
      />
    </template>
  </dynameat-row>
</template>

<script>

import Vue from 'vue';
import { Components, MapGetters } from '@core/helpers/decorators';
import DynameatRow from '@dynameat/components/DynameatRow';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { ProductRecommendation, SubsectionRecommendation } from '../models';

@Component
@Components({ DynameatRow })
@MapGetters(['optimizerLanguage'])
export default class ItemCard extends Vue {
  @Prop({
    Object,
    required: true,
    default: null,
    validator: (obj) => obj instanceof SubsectionRecommendation || obj instanceof ProductRecommendation
  }) item;

  @Prop({ Boolean, default: false }) isLastItem;

  @Prop({ Boolean, default: false }) isFirstItem;

  @Prop({ Boolean, default: false }) isChildProduct;

  @Prop({ Boolean, default: true }) isEditable;

  @Prop({ Boolean, default: false }) areChecksDisabled;

  @Prop({ Boolean, default: true }) hasDivider;

  special = false;

  specialFrame = false;

  isVisible = false;

  order = 0;

  itemName = ''

  get isSubsection() {
    return this.item instanceof SubsectionRecommendation;
  }

  get itemTitle() {
    return this.item.special ? `★ ${this.itemName}` : this.itemName;
  }

  get isFirstItemDisabled() {
    return !this.isEditable || this.isFirstItem;
  }

  get isLastItemDisabled() {
    return !this.isEditable || this.isLastItem;
  }

  onMove(value) {
    this.$emit('move', this.item, value);
  }

  get cardClasses() {
    return {
      invisible: !this.isVisible,
      'child-product': this.isChildProduct,
      'special-frame': this.special,
      subsection: this.isSubsection
    };
  }

  onClickTitle() {
    this.$emit('is-visible', this.item);
  }

  onClickSpecial() {
    this.specialFrame = this.special;
    this.$emit('special', this.item);
    this.$emit('special-frame', this.item);
  }

  onClickFrame() {
    this.$emit('special-frame', this.item);
  }

  created() {
    this.refreshItem(this.item);
  }

  refreshItem(item) {
    if (item instanceof SubsectionRecommendation) {
      this.isVisible = true;
      this.order = item.order;
    } else {
      this.special = item.special;
      this.specialFrame = item.specialFrame;
      this.isVisible = item.is_visible;
      this.order = item.order;
    }
  }

  @Watch('item')
  onItemChanged(newItem) {
    this.refreshItem(newItem);
  }

  @Watch('optimizerLanguage', { immediate: true })
  onOptimizerLanguage(newLanguage) {
    const newText = this.item[`name${newLanguage.charAt(0).toUpperCase() + newLanguage.slice(1)}`];
    if (newText !== '') {
      this.itemName = newText;
    }
  }
}
</script>

<style scoped>
.invisible {
  font-style: italic;
  opacity: 0.5;
}

.child-product {
  margin-left: 20px;
}

.subsection {
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 6px;
}

.top-arrow {
  height: 20px;
  width: 20px;
}

.bottom-arrow {
  height: 20px;
  width: 20px;
  margin-bottom: 10px;
}
</style>

<style>
.dynameat-row-content {
  padding: 5px 5px 5px 5px;
  margin-bottom: 5px;
}

.special-frame .dynameat-row-content {
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-right: 10px;
  margin-left: -1px;
}

.v-input__slot {
  margin-bottom: 0;
}

.col {
  padding: 0;
}

.child-product .v-list-item {
  padding-left: 0;
  padding-right: 0;
}
</style>
